export default __webpack_public_path__ + "static/media/giftbox_animation4.cf47be19.gif";